const lang =
  localStorage.getItem("website_language") != null
    ? localStorage.getItem("website_language")
    : "en"

export const DEFAULT_LANGUAGE = lang
export const LANGUAGE = lang
export const FALLBACK_LANGUAGE = "en"
export const SUPPORTED_LANGUAGES = ["en", "nl"]
